<form class="page d-flex flex-column justify-content-center align-items-center">
  <div class="d-flex flex-column group-login">
    <h2 class="d-flex justify-content-center title mb-5" translate="otp.title"></h2>

    <p class="text-center mb-4" translate="otp.instruction"></p>
    <p translate="otp.warningEnterCode" class="warning-enter-code"></p>

    <label class="form-label label" translate="otp.label"></label>
    <input
      type="text"
      autocomplete="one-time-code"
      [(ngModel)]="otpCode"
      name="otpCode"
      [ngClass]="{ 'is-invalid': hasError }"
      class="form-control mb-2 text-center code-input"
      placeholder="000000"
      maxlength="6"
      tabindex="1"
    />

    <div class="d-flex justify-content-end mb-4 flex-column align-items-end">
      <strong class="forget-password pointer" (click)="resendCode()" translate="otp.resend">
      </strong>
      <small *ngIf="resendOtpSuccess" class="text-success mt-1" translate="otp.resendSuccess">
      </small>
    </div>

    <div class="form-check mb-2">
      <input
        class="form-check-input pointer"
        type="checkbox"
        id="trustDevice"
        [(ngModel)]="isTrusted"
        name="trustDevice"
      />
      <label class="form-check-label label pointer" for="trustDevice" translate="otp.trust_device">
      </label>
    </div>

    <p class="hint mb-4" translate="otp.trust_hint"></p>

    <button
      id="submit"
      [disabled]="otpCode?.length !== 6 || loading"
      (click)="verify()"
      class="btn btn-lg btn-primary btn-login top-49"
      translate="otp.continue"
      tabindex="2"
    ></button>

    <div class="invalid-feedback d-block" *ngIf="hasError" translate="otp.error_invalid"></div>
  </div>
</form>
